var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event)?_c('div',[_c('CultureNav'),_c('ReckonBallPage',{attrs:{"event":_vm.event}}),_c('AppFooter')],1):_c('div',{staticClass:"not-found"},[_c('v-container',[_c('h1',[_vm._v("Reckon Ball year not found")]),_c('v-btn',{attrs:{"to":{ name: 'reckon-ball-archive' }}},[_vm._v("View Reckon Ball")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }